// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LxP-","option":"styles_option__2m3Lx","active":"styles_active__2Mmzi"};